import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import ProductSpot from '@/shared/product/spot/ui/ProductSpot.vue';
import { computed } from 'vue';
import { ProductSpotModel } from '@/types/productServerApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpotSwiper',
  props: {
    productList: null
  },
  emits: ["select-item"],
  setup(__props: any, { emit }: { emit: ({(e: 'select-item', product: ProductSpotModel, index: number): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { productList: ProductSpotModel[] }





const isMobile = computed(() => breakpointsState.activeBreakpoint === 'xs');
const isTablet = computed(() => breakpointsState.activeBreakpoint === 'sm');
const isLargeDesktop = computed(() => breakpointsState.activeBreakpoint === 'xl');
const freeMode = computed(() => isMobile.value || isTablet.value);

const swiperOptions = computed(() => {
    let slidesPerView = 4.6;
    let slidesOffset = 24;
    let slidesPerGroup = 4;
    if (isMobile.value) {
        slidesPerView = 2.3;
    } else if (isTablet.value) {
        slidesPerView = 3.6;
    } else if (isLargeDesktop.value) {
        slidesOffset = 64;
    }

    // Fix for miscalculation in swiper.js
    if (props.productList.length % slidesPerGroup > 0) {
        slidesPerGroup = 3;
    }

    return {
        spaceBetween: isMobile.value ? 16 : 24,
        slidesPerGroup,
        slidesPerView,
        slidesOffsetBefore: slidesOffset,
        slidesOffsetAfter: slidesOffset,
        watchSlidesVisibility: true,
    };
});


return (_ctx: any,_cache: any) => {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createBlock(_component_Swiper, {
    "free-mode": _unref(freeMode),
    class: _normalizeClass({swiper: !_unref(freeMode)}),
    options: _unref(swiperOptions)
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.productList, (product, index) => {
        return (_openBlock(), _createBlock(_component_SwiperSlide, {
          key: product.id+index,
          class: "swiper-item"
        }, {
          default: _withCtx(() => [
            _createVNode(ProductSpot, {
              product: product,
              onClickPassive: ($event: any) => (emit('select-item', product, index))
            }, null, 8, ["product", "onClickPassive"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["free-mode", "class", "options"]))
}
}

})